module.exports = __webpack_public_path__ + "img/1.3f9d38b.png";